module.exports = __webpack_public_path__ + "static/img/restaurant-filter-icon01.bffe2dc6.svg";